<script>
import _ from 'lodash'
import {AnswerStore} from './AnswerStore'
import VueUploadComponent from 'vue-upload-component'

/**
 *
 * This works by using the vue-upload-component.
 * The component works by calling things by reference. It uses its own array (attachmentfiles)
 * but we have to maintain our own too, this is so we can populate the list of attachments already stored
 * and allow the user to delete them. If we didn't care about showing what was uploaded, we wouldn't need to bother
 * with a lot of this!
 *
 * Otherwise, it's the same as the answer.vue AppAnswer object
 *
 * What the answer stores in the db, is a json string.
 * lastmodified shows the date that string was changed.
 *
 *
 */
export default {

  components: {
    FileUpload: VueUploadComponent,
  },

  props: {
    idappcode: String,
    idquestion: Number,
    countwords: Boolean,
    required: Boolean,
    question: String,
    help: String,
    ServerAnswer: String,
    ServerLastModified: Number,

  },

  data() {
    return {
      answer: '',
      answerobj: [],
      lastmodified: 0,
      AnswerStore,

      attachmentfiles: [],
      themosis: window.themosis,
      errormsg: '',
    }

  },

  methods: {

    doRemoveButton(file) {
      /**
       * We search through attachmentfiles to see if the file we referenced is there
       * meaning that we've uploaded it in this session
       * If it's there, the remove function will take care of removing it from the server
       * If it isn't there, we need to do that ourselves
       */

      let uploadedinsession = this.attachmentfiles.filter(function (afile) {
        return ((afile.name === file.name) && (afile.size === file.size) && (afile.type === file.type))
      })


      if (uploadedinsession.length === 1) {

        // https://lian-yue.github.io/vue-upload-component/#/en/documents#instance-methods-remove
        this.$refs.upload.remove(uploadedinsession[0])
        // Note: We don't need call doRemoveAnswerObj here because it will be done via the components callback

      } else {

        this.doRemoveAttachment(file)
        this.doRemoveAnswerObj(file)
      }


    },

    // This adds the uploaded file reference into the answer object we maintain
    doAddAnswerObj(file) {
      this.answerobj.push({
        name: file.name,
        size: file.size,
        type: file.type,
      })
    },

    // This removes the file from our answer object, it is called when vue-upload detects a removal
    doRemoveAnswerObj(file) {
      this.answerobj = this.answerobj.filter(function (val) {
        return !((val.name === file.name) && (val.size === file.size) && (val.type === file.type))
      })
    },

    // Do we already have this file?
    doIsDupCheck(file) {

      return this.answerobj.find(function (val) {
        return ((val.name === file.name) && (val.size === file.size))
      })

    },

    // Blank, but here for completeness. Called when a file is added (select or drag/drop)
    doAddAttachment(file) {
    },

    // Called when the vue-upload-component remove function is called
    doRemoveAttachment(file) {

      // Remove from the server
      jQuery.ajax({
        url: this.themosis.ajaxurl,
        dataType: 'json',
        type: 'POST',
        data: {
          action: 'application-removeattachment',
          security: this.themosis.nonce,
          idappcode: this.idappcode,
          name: file.name,
          size: file.size,
        }
      }).done(function (r) {

        if (r.error !== 'none') {
          this.errormsg = 'Error removing attachment: ' + r.error
        } else {
          //Success here

        }
      }.bind(this)).fail(function (j, error) {
        this.errormsg = 'Communication error: ' + error
      })

    },

    /**
     * https://lian-yue.github.io/vue-upload-component/#/en/documents#options-events-input-file
     *
     * This is called by the vue-upload-component when a file is added or removed
     * @param newFile
     * @param oldFile
     */
    inputFile(newFile, oldFile) {

      // Automatically upload if a new file is seen
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }

      // If a file has been removed (remove function called in the $ref upload obj)
      if (!newFile && oldFile) {
        this.doRemoveAttachment(oldFile)
        this.doRemoveAnswerObj(oldFile)
      }

      // If a file has been added (either select or drag/drop)
      if (newFile && !oldFile) {
        this.doAddAttachment(newFile)
        this.doAddAnswerObj(newFile)
      }

    },

    /**
     * This is called by vue-upload-component just before a file is added
     * It operates as a filter!
     *
     * https://lian-yue.github.io/vue-upload-component/#/en/documents#options-events-input-filter
     */

    inputFilter(newFile, oldFile, prevent) {

      // Add file
      if (newFile && !oldFile) {

        // Filter on file type, will not be added
        let acceptedmimetypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp',
          'application/msword',
          'application/pdf',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ]
        const allowed = acceptedmimetypes.find((val) => val === newFile.type)
        if (!allowed) {
          this.errormsg = "We do not accept the file type: " + newFile.type
          return prevent()
        }

        if (this.doIsDupCheck(newFile)) {
          this.errormsg = 'Duplicate file'
          return prevent()
        }

      }

      if (newFile && oldFile) {
      }

      // File is removed
      if (!newFile && oldFile) {

        // Refused to remove the file
        // return prevent()
      }
    }


  },

  computed: {

    wordcount() {
      return this.answerobj.length
    },

    satisfied() {
      if (this.required === false) {
        return true
      }

      if (this.answerobj.length > 0) {
        return true
      } else {
        return false
      }

    },

  },

  watch: {
    //The watchers are used to essentially copy our properties and computed properties into the AnswerStore

    wordcount: {
      handler(val) {
        this.AnswerStore.wordcounts[this.idquestion] = val
      },
      immediate: true
    },

    satisfied: {
      handler(val) {
        this.AnswerStore.satisfiedes[this.idquestion] = val
      },
      immediate: true
    },

    countwords: {
      handler(val) {
        this.AnswerStore.countwords[this.idquestion] = val
      },
      immediate: true
    },


    // We watch answerobj so it can be turned into a json string which is the actual answer to this question
    answerobj: {
      handler() {
        if (this.answerobj.length > 0) {
          this.answer = JSON.stringify(this.answerobj);

        } else {
          this.answer = ''
        }
      }
      , deep: true
    },

    attachmentfiles: {
      handler(files) {

        let erroroccurred = ''

        //We always get given the whole array so we can search it and find any errors in any upload objects
        files.forEach((element) => {
          if (element.error !== '') {
            console.log(element.error)
            // If there is an error, we remove it from our own answerobj, and show the error to the user
            this.doRemoveAnswerObj(element)
            erroroccurred = element.error
            //We remove the failed upload from the vue upload component too or the error retriggers every time, as it does not clear the error message
            this.$refs.upload.remove(element)
          }
        })

        if (erroroccurred !== '') {
          this.errormsg = erroroccurred
        }
      }

    },


  },

  created: function () {

    // These props don't change so we don't need to make them into watchers and can go straight into AnswerStore
    this.AnswerStore.requireds[this.idquestion] = this.required

    try {
      this.answerobj = JSON.parse(this.ServerAnswer)
    } catch (e) {
      this.answerobj = []
    }

    this.lastmodified = this.ServerLastModified


    //Now the answer and lastmodified is correct from the server, we can setup the watchers

    this.$watch('answer', (val) => {

          this.lastmodified = Date.now()
          this.AnswerStore.answers[this.idquestion] = val


        }, {
          //immediate: true
        }
    )


    this.$watch('lastmodified', (val) => {

      this.AnswerStore.lastmodifieds[this.idquestion] = val

    }, {
      //immediate: true
    })


  },

}

</script>


<template>
  <div class="question-wrap">
    <span class="question-wordscounted" v-if="countwords">*</span>
    <span class="question-required" v-if="required">(Required)</span>
    <div class="question-question" v-html="question"></div>
    <div class="question-help" v-html="help"></div>

    <file-upload
        class="btn btn-primary rounded-pill"
        ref="upload"
        v-model="attachmentfiles"
        :post-action="themosis.ajaxurl"
        :drop="true"
        :multiple="true"
        :drop-directory="true"
        @input-file="inputFile"
        @input-filter="inputFilter"
        accept="image/*,application/msword,application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        :data="{action: 'application-putattachment',
                  lastmodified: Date.now(),
                  security: themosis.nonce,
                  idappcode: idappcode,
          }"
    >Select file(s) for upload
    </file-upload>
    (You mays also drag / drop)
    <table class="table">
      <thead>
      <tr>
        <th>File</th>
        <th>Size</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="file in answerobj">
        <td>{{ file.name }}</td>
        <td>{{ file.size }}</td>
        <td>
          <button type="button" class="btn btn-primary rounded-pill" @click.prevent="doRemoveButton(file)">Remove
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="errormsg !== ''" class="alert alert-danger">
      <button class="btn btn-danger rounded-pill" @click="errormsg ='' ">OK</button>
      <span class="ml-5" v-text="errormsg"></span>

    </div>
    <!--
    <button type="button" class="btn btn-primary rounded-pill" v-if="!$refs.upload || !$refs.upload.active"
            @click.prevent="$refs.upload.active = true">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
      Start Upload
    </button>
    -->
  </div>

</template>